import { AppPageContent } from '@/core/components/app-page-content';
import { ProductsPageContent } from '@/core/components/products/products-page-content';
import { useProductsPage } from '@/core/components/products/use-products-page';
import { AppIonPage } from '@/core/components/app-ion-page';

export function ProductsPage() {
  const page = useProductsPage();

  if (!page.currentWorkspace) {
    return null;
  }

  return (
    <AppIonPage>
      <AppPageContent>
        <ProductsPageContent page={page} />
      </AppPageContent>
    </AppIonPage>
  );
}
